import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { QuotaService } from '../../../quotas/services/quota.service';
import { ApplicationItem } from '../../../quotas/models/application.interface';

export interface ConsiderationDialogData {
  application: ApplicationItem;
}

@Component({
  selector: 'app-consideration-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSnackBarModule
  ],
  templateUrl: './consideration-dialog.component.html',
  styleUrls: ['./consideration-dialog.component.css']
})
export class ConsiderationDialogComponent {
  private quotaService = inject(QuotaService);
  private dialogRef = inject(MatDialogRef<ConsiderationDialogComponent>);
  private snackBar = inject(MatSnackBar);
  data = inject<ConsiderationDialogData>(MAT_DIALOG_DATA);

  loading = signal(false);
  errorMessage = signal('');

  reason = '';

  submit(): void {
    if (!this.reason) return;

    this.loading.set(true);
    this.errorMessage.set('');

    this.quotaService.setUnderConsideration({
      applicationId: this.data.application.id,
      underConsiderationReason: this.reason
    }).subscribe({
      next: (response) => {
        this.loading.set(false);
        if (response.success) {
          this.snackBar.open('Статус успешно обновлен', 'OK', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });
          this.dialogRef.close({ success: true });
        } else {
          this.errorMessage.set(response.msg || 'Ошибка обновления статуса');
        }
      },
      error: (error) => {
        console.error('Error setting under consideration:', error);
        this.errorMessage.set('Ошибка обновления статуса');
        this.loading.set(false);
      }
    });
  }

  close(): void {
    this.dialogRef.close({ success: false });
  }
}
